export default () => ({
  hidden: false,
  orientationActive: false,
  lastY: 0,
  headerH: 0,
  belowMd: typeof window !== 'undefined' ? window.matchMedia('(max-width: 767.98px)').matches : true,

  init() {
    this.$nextTick(() => {
      this.measure()
    })

    // Update breakpoint state and re-measure on resize
    this._resizeHandler = () => {
      this.belowMd = window.matchMedia('(max-width: 767.98px)').matches
      this.measure()
      if (!this.belowMd) {
        // Ensure header is visible when switching to desktop
        this.hidden = false
      }
    }
    window.addEventListener('resize', this._resizeHandler)
  },

  destroy() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
    }
  },

  measure() {
    this.headerH = this.$refs.header?.offsetHeight || 0
  },

  onScroll(e) {
    if (!this.belowMd) {
      return
    }

    const y = e.target?.scrollTop || 0
    if (this.orientationActive) {
      this.hidden = false
      this.lastY = y
      return
    }

    const delta = y - this.lastY

    // Hide when scrolling down; show when scrolling up
    if (y > 24 && delta > 2) {
      this.hidden = true
    } else if (delta < -2) {
      this.hidden = false
    }

    // Always show when at the very top
    if (y <= 0) {
      this.hidden = false
    }

    this.lastY = y
  },

  /**
   * Below md the header is taken out of the flow and laid over the scroll area,
   * so the padding keeps the content clear of it. `--app-sticky-top` publishes
   * where a sticky element inside the scroll area has to start to stay clear of
   * it as well; it follows the header out of the way while reading downwards, so
   * a sticky element never leaves a gap behind a header that is not there.
   */
  get mainStyle() {
    if (!this.belowMd) {
      return '--app-sticky-top: 0px;'
    }

    return `padding-top: ${this.headerH}px; --app-sticky-top: ${this.hidden ? 0 : this.headerH}px;`
  }
})
